var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from '@marketing-icons';
import { clsx } from 'clsx';
function NavPill(_a) {
    var active = _a.active, onClick = _a.onClick, index = _a.index, theme = _a.theme;
    var backgroundColor = theme === 'dark' ? 'bg-surface-white' : 'bg-surface-black';
    return (_jsx("button", { "aria-label": "Go to slide ".concat(index), onClick: onClick, className: "rounded-full transition-all ease-in-out duration-200 ".concat(backgroundColor, " w-[20px] h-[10px] md:w-[28px] md:h-[14px] opacity-25 ").concat(active ? '!opacity-100 !w-[30px] md:!w-[42px]' : '') }));
}
function Controls(_a) {
    var numItems = _a.numItems, onSelectIndex = _a.onSelectIndex, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b, _c = _a.currentIndex, currentIndex = _c === void 0 ? 0 : _c;
    return (_jsxs("div", __assign({ className: "w-full flex justify-between items-center" }, { children: [_jsx("button", __assign({ "aria-label": "Previous slide", onClick: function () {
                    onSelectIndex((currentIndex - 1 + numItems) % numItems);
                }, className: clsx('flex w-[9px] h-[15px] justify-start items-center mr-2 shrink-0', theme === 'light' ? 'text-icon-dark' : 'text-icon-white') }, { children: _jsx(ChevronLeftIcon, {}) })), _jsx("div", __assign({ className: "flex gap-2xs-button" }, { children: Array.from({ length: numItems }).map(function (_, index) { return (_jsx(NavPill, { onClick: function () {
                        onSelectIndex(index);
                    }, index: index, active: index === currentIndex, theme: theme }, index)); }) })), _jsx("button", __assign({ "aria-label": "Next slide", onClick: function () {
                    onSelectIndex((currentIndex + 1) % numItems);
                }, className: clsx('flex w-[9px] h-[15px] justify-end items-center ml-2 shrink-0', theme === 'light' ? 'text-icon-dark' : 'text-icon-white') }, { children: _jsx(ChevronRightIcon, {}) }))] })));
}
export default Controls;
